import type { AdminMe } from "@vital/shared";
import { cmsStrings } from "../terminology";
import { LtrIsolate } from "./LtrIsolate";

const ROLE_LABELS: Record<string, string> = {
  owner: cmsStrings.roles.owner,
  publisher: cmsStrings.roles.publisher,
  editor: cmsStrings.roles.editor,
  auditor: cmsStrings.roles.auditor,
  tenant_admin: cmsStrings.roles.tenant_admin,
};

type Props = {
  user: AdminMe;
  onLogout: () => void;
};

export function SidebarUserCard({ user, onLogout }: Props) {
  const roleLabel =
    (user.membershipRole && ROLE_LABELS[user.membershipRole]) ||
    ROLE_LABELS[user.role] ||
    user.role;

  return (
    <div className="sidebar-user" data-vt-sidebar-user>
      <div className="sidebar-user__avatar" aria-hidden="true">
        {user.displayName.slice(0, 1)}
      </div>
      <p className="sidebar-user__name">{user.displayName}</p>
      <p className="sidebar-user__email">
        <LtrIsolate>{user.email}</LtrIsolate>
      </p>
      <span className="sidebar-user__role">{roleLabel}</span>
      <div className="sidebar-user__actions">
        <button type="button" className="sidebar-user__link sidebar-user__link--button" onClick={onLogout}>
          {cmsStrings.shell.logout}
        </button>
      </div>
    </div>
  );
}
